import { createListenerMiddleware } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import config from './Config';
import queryParamTerm from './QueryParamTerm';
export const rootReducer = combineReducers({
  config,
  queryParamTerm
});

// This type represents the state of your root reducer,
// and can be useful when creating selectors
export const createAppListenerMiddleware = createListenerMiddleware;

// Should be used in place of useDispatch throughout the application
export function useAppDispatch() {
  return useDispatch();
}
export const useAppSelector = useSelector;